"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("@findify/analytics/lib/types");
var decamelize_1 = require("../helpers/decamelize");
var nodeToArray = function (node) { return Array.prototype.slice.call(node); };
var normalizeKeys = function (obj) {
    if (obj === void 0) { obj = {}; }
    return Object.keys(obj).reduce(function (acc, key) {
        return (__assign({}, acc, (_a = {}, _a[decamelize_1.decamelize(key).replace('findify_', '')] = obj[key], _a)));
        var _a;
    }, {});
};
var normalizeClass = function (name) {
    return ({
        product_id: 'item_id',
        price_currency_code: 'currency',
        order_number: 'order_id',
    }[name] || name);
};
var getPropsFromChildren = function (nodeList) {
    return nodeToArray(nodeList).reduce(function (acc, element) {
        return (__assign({}, acc, normalizeKeys(element.dataset), (!!element.className && (_a = {},
            _a[normalizeClass(element.className)] = (!element.children.length &&
                element.innerText) || (acc[normalizeClass(element.className)] || []).concat([
                getPropsFromChildren(element.children),
            ]),
            _a))));
        var _a;
    }, {});
};
exports.getEventData = function (node) {
    var ownProps = normalizeKeys(node.dataset);
    if ([types_1.EventName.purchase, types_1.EventName.updateCart].includes(ownProps.event)) {
        return __assign({}, ownProps, { line_items: nodeToArray(node.children).map(function (e) { return normalizeKeys(e.dataset); }) });
    }
    var childrenProps = getPropsFromChildren(node.children);
    return __assign({}, ownProps, childrenProps);
};
exports.getEventsOnPage = function (root) {
    return nodeToArray(root.querySelectorAll('[data-findify-event]'))
        .map(exports.getEventData)
        .reduce(function (acc, _a) {
        var event = _a.event, rest = __rest(_a, ["event"]);
        return (__assign({}, acc, (_b = {}, _b[event] = rest, _b)));
        var _b;
    }, {});
};
exports.getDeprecatedEvents = function (root) {
    var events = {};
    var pageViewNode = root.querySelector('.findify_page_product');
    var purchaseNode = root.querySelector('.findify_purchase_order');
    if (!!pageViewNode) {
        var pageViewContent = { item_id: pageViewNode.innerHTML };
        events['page-view'] = pageViewContent;
        events['view-page'] = pageViewContent;
    }
    if (!!purchaseNode) {
        var _a = getPropsFromChildren(purchaseNode.children), line_item = _a.line_item, data = __rest(_a, ["line_item"]);
        events['purchase'] = __assign({}, data, { line_items: line_item, revenue: line_item &&
                line_item.length &&
                line_item.reduce(function (amount, _a) {
                    var unit_price = _a.unit_price;
                    return amount + parseFloat(unit_price);
                }, 0) });
    }
    return events;
};
//# sourceMappingURL=events.js.map